export default "__VITE_ASSET__D7_cGh7a__"